module.exports = __webpack_public_path__ + "img/verification-human.855adfa1.svg";